import moment from 'moment-timezone';

const ALLOWED_PERIOD_DAYS = 3;

export const isWithinEditableWindow = (effectiveDate) => {
  const allowedPeriod = moment().utc().subtract(ALLOWED_PERIOD_DAYS, 'days');

  return moment(effectiveDate || new Date()).isAfter(allowedPeriod);
};
